export default __webpack_public_path__ + "static/media/facil2.21a2d1ea.png";